module.exports = __webpack_public_path__ + "img/honor3.32ae25b6.png";